export default {
  baseUrl: (location.hostname !== 'localhost') ? `https://${location.hostname}/db/` : 'https://maihyp.snsolutions.fr/db/'
  // baseUrl: 'https://maihyp.snsolutions.fr/db/' // for running in local
  // baseUrl: 'https://maihyp.synology.me/db/'
  // baseUrl: 'http://151.127.36.114:60080/db/'
  // baseUrl: 'http://localhost/maihyp/'
}
